import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
// import {
//   AssignFacilitatorRequest,
//   FacilitatorModel,
//   FacilitatorRequest,
// } from '@tsin-core/models/facilitator.model';
import { environment } from '@tsin-env/environment';
import { map, shareReplay } from 'rxjs';

const USER_URL = `${environment.authBaseUrl}`;
const GUESTS_API_URL = `${environment.authBaseUrl}/guest`;
const FACILITATOR_URL = `${environment.learningBaseUrl}/facilitators`;
const LEARNING_URL = `${environment.learningBaseUrl}`;


@Injectable({
  providedIn: 'root',
})
export class UserService {
  // inject the http client into the user service
  http: HttpClient = inject(HttpClient);



}
